import script from "./settingCustomFieldComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./settingCustomFieldComponent.vue?vue&type=script&setup=true&lang=js"

import "./settingCustomFieldComponent.vue?vue&type=style&index=0&id=ff6945f8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff6945f8"]])

export default __exports__